import { CommonFileNavTreeComponent } from "./common-file-nav-tree/common-file-nav-tree";
import { NavTreeSearchBarComponent } from "./common-file-nav-tree/search-bar/search-bar";
import { TabBarToolbar } from "./tool-bar/tool-bar";
import { NavPanelComponent } from "./nav-panel.component";
import { NavPanelFactory } from "./nav-panel.factory";
import { NavTreeSearchService } from './common-file-nav-tree/search-bar/search.service';

/** 导航面板相关的需要声明的组件 */
export const NAV_PANEL_COMPONENTS = [
  NavPanelComponent,
  CommonFileNavTreeComponent,
  NavTreeSearchBarComponent,
  TabBarToolbar
];

/** 导航面板相关的需要动态加载的组件 */
export const NAV_PANEL_ENTRY_COMPONENTS = [
  CommonFileNavTreeComponent,
  NavTreeSearchBarComponent,
  TabBarToolbar
];

/** 导航面板相关的服务提供者 */
export const NAV_PANEL_PROVIDERS = [
  NavPanelFactory,
  NavTreeSearchService
];
